import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../../../auth/store/actions';
import { API } from "../../../config";
//import { CSVLink } from "react-csv";
import Util from "../../../yeffect/utils";
import {Table, TableBody, TableCell, TableHead, TableRow, Paper} from "@material-ui/core";

const Certificates = API.service('certificates');
const Brokers = API.service('authorized-brokers');
const Companies = API.service('company');

//const moment = require('moment');

const styles = theme => ({
    layoutRoot: {}
});

class CustodianRec extends Component {
    state = {
        certificates:false,
        brokers:false,
        companies:false,
        csd:false,
        days:false,
        headers:[
            {balh:1,blh2:2,kjh:3},
            {balh:1,blh2:2,kjh:3},
            {balh:1,blh2:2,kjh:3},
            {balh:1,blh2:2,kjh:3},
        ]
    };

    componentDidMount() {

        let brokers = {};
        let companies = {};

        Certificates.find({query:{$limit:100,type:'group'}}).then(c=>{
            Brokers.find({query:{$limit:100}}).then(b=> {

                console.log(b);
                b.data.forEach(b1=>{
                    brokers[b1._id.toString()] = b1;
                })

                Companies.find({query:{$limit:100}}).then(co=> {
                    console.log(co);
                    co.data.forEach(c1=>{
                        companies[c1._company_account.toString()] = c1;
                    })

                    this.setState({
                        certificates: c,
                        brokers: brokers,
                        companies: companies,
                    })
                })

            });
        })
    }

    uploadFile = (e) => {
        const app = this;
        var f = e.target.files[0];
        var output = '';
        if (f) {
            var r = new FileReader();
            r.onload = function(e) {
                var contents = e.target.result;

                var data = [];
                var csd = {};
                var lines = contents.split("\n"), output = [];
                for (var i=1; i<lines.length; i++){
                    data.push(lines[i].split(","));
                    output.push("<tr><td>" + lines[i].split(",").join("</td><td>") + "</td></tr>");
                }

                console.log(data);
                data.forEach(cert => {
                    csd[cert[1]] = cert;
                });

                output = "<table>" + output.join("") + "</table>";
                console.log(output);

                app.setState({
                    csd: csd
                })
            };
            r.readAsText(f);
            console.log(output);
        } else {
            alert("Failed to load file");
        }
    }

    render()
    {
        const {classes} = this.props;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Custodial Holdings Reconciliation</h4></div>
                }
                content={
                    <div>
                        <Paper style={{marginTop:10,padding:20}}>
                            Upload Custodial Supplied CSV:&nbsp;&nbsp;
                            <input type={'file'} onChange={this.uploadFile}/>
                        </Paper>

                        <Paper style={{marginTop:10,padding:20}}>
                            <Table>
                                <TableHead>
                                <TableRow>
                                    <TableCell>Instrument</TableCell>
                                    <TableCell>Broker</TableCell>
                                    <TableCell>SafeKeeping Account</TableCell>
                                    <TableCell>Custodial Identifier</TableCell>
                                    <TableCell>Broker Holdings</TableCell>
                                    <TableCell>Custodial Holdings</TableCell>
                                    <TableCell>Discrepancy</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {(this.state.certificates !== false) &&
                                <React.Fragment>
                                    {this.state.certificates.map(cert => {
                                        return (
                                          <TableRow>
                                              <TableCell>{(typeof this.state.companies[cert._account.toString()] !== "undefined") ? this.state.companies[cert._account.toString()]._company_name : cert._account}</TableCell>
                                              <TableCell>{(typeof this.state.brokers[cert.broker_id] !== "undefined") ? this.state.brokers[cert.broker_id]._name : cert.broker_id}</TableCell>
                                              <TableCell>{cert.custodial_safekeeping_account}</TableCell>
                                              <TableCell>{cert.custodial_identifier}</TableCell>
                                              <TableCell>{Util.addThousandCommas(cert._holdings)}</TableCell>
                                              <TableCell>{(typeof this.state.csd[cert.custodial_identifier] !== "undefined") ? Util.addThousandCommas(this.state.csd[cert.custodial_identifier][7]) : ''}</TableCell>
                                              <TableCell>{(this.state.csd !== false) ?  (typeof this.state.csd[cert.custodial_identifier] !== "undefined") ? Util.addThousandCommas(cert._holdings - this.state.csd[cert.custodial_identifier][7]) : Util.addThousandCommas(cert._holdings) : ''}</TableCell>
                                          </TableRow>
                                        )
                                    })}
                                </React.Fragment>
                                }
                                </TableBody>
                            </Table>
                        </Paper>
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        setUserData: Actions.setUserData,
        setUserDataFromDB: Actions.setUserDataFromDB,
    }, dispatch);
}

function mapStateToProps({fuse, auth})
{
    return {
        login   : auth.login,
        user    : auth.user
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps,mapDispatchToProps)(CustodianRec));



// WEBPACK FOOTER //
// ./src/main/content/custodian/CustodianRec.js